import CryptoJS from "crypto-js";
import {Buffer} from "buffer";

export default {

   install(Vue) { /* Vue */

      // Vue.config.globalProperties.$makeApiUrl_Verification = (kind) => {
      //    let apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_URL_COMMON_VERIFICATION;
      //    let apiKind = "";
      //
      //    switch(kind){
      //       case 'emailIssu':
      //          apiKind = "/email/issu";
      //          break;
      //       case 'emailCnfirm':
      //          apiKind = "/email/cnfirm";
      //          break;
      //       case 'mbtlnumIssu':
      //          apiKind = "/mbtlnum/issu";
      //          break;
      //       case 'mbtlnumCnfirm':
      //          apiKind = "/mbtlnum/cnfirm";
      //          break;
      //    }
      //
      //    return apiUrl+apiKind;
      // };

      // // 사용자 API
      // Vue.config.globalProperties.$makeApiUrl_Identifier = (kind) => {
      //    let apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_URL_COMMON_IDENTIFIER;
      //    let apiKind = "";
      //
      //    switch(kind){
      //       case 'exst':
      //          apiKind = "/exst";
      //          break;
      //
      //       case 'secsn':
      //          apiKind = "/secsn";
      //          break;
      //    }
      //
      //    return apiUrl+apiKind;
      // };

      // 첨부파일 API
      Vue.config.globalProperties.$makeApiUrl_AttachmentFile = (kind) => {
         let apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_URL_COMMON_ATCHMNFL;
         let apiKind = "";

         switch(kind){
            case 'inquiry':
               break;

            case 'img':
               apiKind = "/img";
               break;

            case 'thumb':
               apiKind = "/thumb";
               break;

            case 'dwld':
               apiKind = "/dwld";
               break;
         }

         // console.log("apiUrl : " + apiUrl);
         // console.log("apiKind : " + apiKind);
         return apiUrl+apiKind;
      };

      // 통계 API
      Vue.config.globalProperties.$makeApiUrl_Statistics = (kind) => {
         let apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_URL_COMMON_STATISTICS;
         let apiKind = "";

         switch(kind){
            case 'totalIdentifier':
               apiKind = "/tot/idntfr";
               break;

            case 'totalFarmName':
               apiKind = "/tot/fnm";
               break;
         }

         // console.log("apiUrl : " + apiUrl);
         // console.log("apiKind : " + apiKind);
         return apiUrl+apiKind;
      };

      // 서비스 공지 게시판 API
      Vue.config.globalProperties.$makeApiUrl_ServiceBoard_Notice = (kind) => {
         let apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_URL_COMMON_SRV_BBS_NOTICE;
         let apiKind = "";

         switch(kind){
            case 'recent':
               apiKind = "/recent";
               break;

            case 'list':
               apiKind = "/pagingList";
               break;

            case 'info':
               apiKind = "/info";
               break;
         }

         // console.log("apiUrl : " + apiUrl);
         // console.log("apiKind : " + apiKind);
         return apiUrl+apiKind;
      };

      // 서비스 FAQ 게시판 API
      Vue.config.globalProperties.$makeApiUrl_ServiceBoard_Faq = (kind) => {
         let apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_URL_COMMON_SRV_BBS_FAQ;
         let apiKind = "";

         switch(kind){
            case 'recent':
               apiKind = "/recent";
               break;

            case 'list':
               apiKind = "/pagingList";
               break;

            case 'info':
               apiKind = "/info";
               break;
         }

         // console.log("apiUrl : " + apiUrl);
         // console.log("apiKind : " + apiKind);
         return apiUrl+apiKind;
      };

      // Vue.config.globalProperties.$getBbsId = (code) => {
      //    let result={};
      //
      //    if(code=='IWENTC'){
      //       //공식홈페이지-공지사항
      //       result = {
      //          bbsToken: "Qf1Q33M3029ARLXNC202T1Y6",
      //          pageName: "공식 홈페이지"
      //       };
      //    }else if(code=='IWEFAQ'){
      //       //공식홈페이지-FAQ
      //       result = {
      //          bbsToken: "R1nFe2623P0N120T7tU21Y12",
      //          pageName: "공식 홈페이지"
      //       };
      //    }else if(code=='PTNNTC'){
      //       //파트너홈페이지-공지사항
      //       result = {
      //          bbsToken: "aT1Ym3gm30Uo0YI2261M6mIA",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(code=='PTNFAQ'){
      //       //파트너홈페이지-FAQ
      //       result = {
      //          bbsToken: "Xq01Mj6r72ej1YzM29xI300V",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(code=='PTNDLB'){
      //       //파트너홈페이지-자료실
      //       result = {
      //          bbsToken: "02X731qf03CU2t2X1ZT6Wr3A",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(code=='PTNQNA'){
      //       //파트너홈페이지-QNA
      //       result = {
      //          bbsToken: "E256O0i6oqSNtR3na2ArZ011",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(code=='PTNPOP'){
      //       //파트너홈페이지-팝업 공지
      //       result = {
      //          bbsToken: "Jk2ASR50G2Ja1xua29i0Vt3s",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(code=='APTNTC'){
      //       //폐품:쏙 파트너스 어플-공지사항
      //       result = {
      //          bbsToken: "yq2v6pOyJ236Cd1uEc02O0CS",
      //          pageName: "폐품:쏙 파트너스 어플"
      //       };
      //    }else if(code=='APTFAQ'){
      //       //폐품:쏙 파트너스 어플-FAQ
      //       result = {
      //          bbsToken: "s0wi6VDW0L1P22lii2p3gjor",
      //          pageName: "폐품:쏙 파트너스 어플"
      //       };
      //    }else if(code=='AURNTC'){
      //       //폐품:쏙 이용자 어플-공지사항
      //       result = {
      //          bbsToken: "0Jz2mZzy30WwIB0p8L1262yE",
      //          pageName: "폐품:쏙 이용자 어플"
      //       };
      //    }else if(code=='AURFAQ'){
      //       //폐품:쏙 이용자 어플-FAQ
      //       result = {
      //          bbsToken: "00JF23y96T5iOk2lR23c01Tr",
      //          pageName: "폐품:쏙 이용자 어플"
      //       };
      //    }
      //
      //    return result;
      // };

      // Vue.config.globalProperties.$getBbsCode = (id) => {
      //    let result={};
      //
      //    if(id=='Qf1Q33M3029ARLXNC202T1Y6'){
      //       //공식홈페이지-공지사항
      //       result = {
      //          bbsCode: "IWENTC",
      //          pageName: "공식 홈페이지"
      //       };
      //    }else if(id=='R1nFe2623P0N120T7tU21Y12'){
      //       //공식홈페이지-FAQ
      //       result = {
      //          bbsCode: "IWEFAQ",
      //          pageName: "공식 홈페이지"
      //       };
      //    }else if(id=='aT1Ym3gm30Uo0YI2261M6mIA'){
      //       //파트너홈페이지-공지사항
      //       result = {
      //          bbsCode: "PTNNTC",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(id=='Xq01Mj6r72ej1YzM29xI300V'){
      //       //파트너홈페이지-FAQ
      //       result = {
      //          bbsCode: "PTNFAQ",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(id=='02X731qf03CU2t2X1ZT6Wr3A'){
      //       //파트너홈페이지-자료실
      //       result = {
      //          bbsCode: "PTNDLB",
      //       };
      //       result="PTNDLB";
      //    }else if(id=='E256O0i6oqSNtR3na2ArZ011'){
      //       //파트너홈페이지-QNA
      //       result = {
      //          bbsCode: "PTNQNA",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(id=='Jk2ASR50G2Ja1xua29i0Vt3s'){
      //       //파트너홈페이지-팝업 공지
      //       result = {
      //          bbsCode: "PTNPOP",
      //          pageName: "파트너 홈페이지"
      //       };
      //    }else if(id=='yq2v6pOyJ236Cd1uEc02O0CS'){
      //       //폐품:쏙 파트너스 어플-공지사항
      //       result = {
      //          bbsCode: "APTNTC",
      //          pageName: "폐품:쏙 파트너스 어플"
      //       };
      //    }else if(id=='s0wi6VDW0L1P22lii2p3gjor'){
      //       //폐품:쏙 파트너스 어플-FAQ
      //       result = {
      //          bbsCode: "APTFAQ",
      //          pageName: "폐품:쏙 파트너스 어플"
      //       };
      //    }else if(id=='0Jz2mZzy30WwIB0p8L1262yE'){
      //       //폐품:쏙 이용자 어플-공지사항
      //       result = {
      //          bbsCode: "AURNTC",
      //          pageName: "폐품:쏙 이용자 어플"
      //       };
      //    }else if(id=='00JF23y96T5iOk2lR23c01Tr'){
      //       //폐품:쏙 이용자 어플-FAQ
      //       result = {
      //          bbsCode: "AURFAQ",
      //          pageName: "폐품:쏙 이용자 어플"
      //       };
      //    }
      //
      //    return result;
      // };

      Vue.config.globalProperties.$parseJwt = (token) => {
         let base64Url = token.split('.')[1];
         let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
         let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
         }).join(''));

         return JSON.parse(jsonPayload);
      };

      Vue.config.globalProperties.$generateSecureCode = (length = 16) => {
         const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
         let result = '';
         const randomValues = new Uint32Array(length);
         window.crypto.getRandomValues(randomValues);

         for (let i = 0; i < length; i++) {
            result += charset[randomValues[i] % charset.length];
         }
         return result;
      };

      Vue.config.globalProperties.$makeAES_Encrypt = (iv, key, plainText) => {
         const IV = CryptoJS.enc.Utf8.parse(iv);
         const KEY = CryptoJS.enc.Utf8.parse(key);

         const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
            iv: IV
            , mode: CryptoJS.mode.CBC
            , padding: CryptoJS.pad.Pkcs7,
         });
         return encrypted.toString();
      };

      Vue.config.globalProperties.$makeAES_SecretKey = (iv, key) => {
         const buffer = Buffer.from(iv + key, 'utf-8');
         return buffer.toString('base64');
      };
   }
}